// applicationUsersReducer.js

const applicationUsersReducer = (draft, action) => {
  switch (action.type) {
    case "SET_USERS":
      draft.allUsersData = action.payload;
      break;
    case "ADD_USER":
      draft.allUsersData.push(action.payload);
      break;
    case "EDIT_USER":
      const { id, userData } = action.payload;
      const index = draft.allUsersData.findIndex((user) => user.id === id);
      if (index !== -1) {
        draft.allUsersData[index] = { ...draft.allUsersData[index], ...userData };
      }
      break;
    case "DELETE_USER":
      draft.allUsersData = draft.allUsersData.filter((user) => user.id !== action.payload);
      break;
    case "SET_LOADER":
      draft.isLoader = action.payload;
      break;
    case "SET_MODAL":
      draft.modal.isOpen = action.payload.isOpen;
      draft.modal.data = action.payload.data || {};
      break;
    case "SET_SEARCH_QUERY":
      draft.searchQuery = action.payload;
      break;
    default:
      break;
  }
};

export default applicationUsersReducer;
